/** Internal type. DO NOT USE DIRECTLY. */
type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
/** Internal type. DO NOT USE DIRECTLY. */
export type Incremental<T> = T | { [P in keyof T]?: P extends ' $fragmentName' | '__typename' ? T[P] : never };
import type * as Types from '../../../../__generated__/zeus/types';

import type { DocumentTypeDecoration } from '@graphql-typed-document-node/core';
/** Feedback about a home viewed during a tour. */
export type BuyerTourFeedbackSubmitInput = {
  /** Aspects the customer disliked; at most 20 can be submitted. */
  dislikedAspects?: Array<Types.Scalars['NonEmptyString']['input']> | null | undefined;
  /** Optional free-form feedback, up to 5,000 characters. */
  freeText?: Types.Scalars['NonEmptyString']['input'] | null | undefined;
  /** Home the feedback concerns; provide exactly one home identifier. */
  home: TouredHomeInput;
  /** Aspects the customer liked; at most 20 can be submitted. */
  likedAspects?: Array<Types.Scalars['NonEmptyString']['input']> | null | undefined;
  /** Overall sentiment about the tour experience; UNSPECIFIED is reserved for reads. */
  sentiment: TourFeedbackSentiment;
  /** Product surface that collected the feedback; AGENT_SMS is reserved for SMS capture. */
  source: TourFeedbackSource;
  /** Optional appointment to associate with the feedback. */
  viewingAppointmentId?: Types.Scalars['NonEmptyString']['input'] | null | undefined;
  /** Whether the customer wants to see similar homes. */
  wantsSimilarHomes?: Types.Scalars['Boolean']['input'] | null | undefined;
};

/** Customer sentiment about a home tour. */
export type TourFeedbackSentiment =
  /** Customer had a negative experience. */
  | 'NEGATIVE'
  /** Customer had a neutral experience. */
  | 'NEUTRAL'
  /** Customer had a positive experience. */
  | 'POSITIVE'
  /** Feedback has no assigned sentiment. */
  | 'UNSPECIFIED';

/** Product surface that prompted tour feedback. */
export type TourFeedbackSource =
  /** Agent feedback collected through SMS. */
  | 'AGENT_SMS'
  /** Feedback collected from an email prompt. */
  | 'EMAIL_PROMPT'
  /** Feedback entered manually by the customer. */
  | 'MANUAL'
  /** Feedback collected from the mobile home carousel. */
  | 'MOBILE_CAROUSEL'
  /** Feedback collected from the post-tour modal. */
  | 'POST_TOUR_MODAL'
  /** Feedback collected from a push notification. */
  | 'PUSH_NOTIFICATION';

/** Exactly one identifier for the home associated with tour feedback. */
export type TouredHomeInput =
  {   /** Address ID of the toured home. */
  addressId: Types.Scalars['UUID']['input']; channelId?: never; listingId?: never; }
  |  { addressId?: never;   /** Channel ID of the toured home. */
  channelId: Types.Scalars['UUID']['input']; listingId?: never; }
  |  { addressId?: never; channelId?: never;   /** Listing ID of the toured home. */
  listingId: Types.Scalars['NonEmptyString']['input']; };

export type HubBuyerTourFeedbackSubmitMutationVariables = Exact<{
  input: Types.BuyerTourFeedbackSubmitInput;
}>;


export type HubBuyerTourFeedbackSubmitMutation = { buyerTourFeedbackSubmit:
    | { __typename: 'InvalidInputError' }
    | { __typename: 'NotFoundError' }
    | { __typename: 'TourFeedback', id: Types.Scalars['ID']['output'], sentiment: Types.TourFeedbackSentiment, viewingAppointmentId: Types.Scalars['NonEmptyString']['output'] | null }
    | { __typename: 'UnauthorizedError' }
   };

export class TypedDocumentString<TResult, TVariables>
  extends String
  implements DocumentTypeDecoration<TResult, TVariables>
{
  __apiType?: NonNullable<DocumentTypeDecoration<TResult, TVariables>['__apiType']>;
  private value: string;
  public __meta__?: Record<string, any> | undefined;

  constructor(value: string, __meta__?: Record<string, any> | undefined) {
    super(value);
    this.value = value;
    this.__meta__ = __meta__;
  }

  override toString(): string & DocumentTypeDecoration<TResult, TVariables> {
    return this.value;
  }
}

export const HubBuyerTourFeedbackSubmitDocument = /*#__PURE__*/ new TypedDocumentString(`
    mutation HubBuyerTourFeedbackSubmit($input: BuyerTourFeedbackSubmitInput!) {
  buyerTourFeedbackSubmit(input: $input) {
    __typename
    ... on TourFeedback {
      id
      sentiment
      viewingAppointmentId
    }
  }
}
    `) as unknown as TypedDocumentString<HubBuyerTourFeedbackSubmitMutation, HubBuyerTourFeedbackSubmitMutationVariables>;